

import React, { useEffect, useMemo, useState } from 'react'
import createAxiosInstance from "../../../../utils/axiosInstance";
import { API_ENDPOINTS } from '../../../../utils/api';
import { Link, useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import { formatDateShort, formatDateTime, formatToUSD } from '../../../../utils/formatters';
import useUserData from '../../../../hooks/useUserData';
import Loader from '../../../../Components/Loader';

const DonorsDetails = () => {
  const me = useUserData();
  const [donor, setDonorDetails] = useState<any>([]);
  const [donations, setDonorDonations] = useState<any>([]);
  const [isLoding, setIsLoding] = useState(true);
  const axiosInstance = createAxiosInstance();
  const { donorId } = useParams();

  useEffect(() => {
    getDonorDetails();
  }, [me]);

  const getDonorDetails = async () => {
    try {
      const response = await axiosInstance.get(`${API_ENDPOINTS.SAFENIIGHT.GETDONERS}/${donorId}`);

      const data = response.data; // Extract the actual data

      const res = await axiosInstance.get(`${API_ENDPOINTS.SAFENIIGHT.GETDONORDONATIONS.replace("{donorId}", donorId ?? "")}?expand=need/assessments,donor&orderBy=donationDate+desc`);

      const donorDonations = res.data;

      setDonorDetails(data);
      setDonorDonations(donorDonations);
      setIsLoding(false);
    } catch (error) {
      setIsLoding(false);
      console.log(error);
    }
  };

  const donationSum = useMemo(
    () =>
      donations?.reduce(function (memo: any, item: any) {
        return memo + item?.amountReceived;
      }, 0),
    [donations]
  );

  const handleEventBlock = async (event: any) => {
    try {
      setIsLoding(true);
      const payload: any = {};
      if (event.target.checked) {
        payload.blocked = [me?.agencyId];
      } else {
        payload.blocked = [];
      }

      await axiosInstance.put(`${API_ENDPOINTS.SAFENIIGHT.GETDONERS}/${donorId}`, payload);

      getDonorDetails();
      setIsLoding(false);
    } catch (error) {
      setIsLoding(false);
      console.log(error);
    }
  };

  return (
    <>
      {isLoding && <Loader />}
      <div className="container py-4 md:py-10 2xl:py-[70px] flex justify-center">
        <div className="w-full xl:w-2/3">
          <div className="card mt-5 p-4 md:p-6">
            <h2 className='text-base lg:text-lg 2xl:text-2xl font-semibold'>{donor?.firstName} {donor?.lastName}</h2>
            <div className="border border-borderGray rounded-xl overflow-hidden mt-5">
              <table className="w-full text-xs 2xl:text-sm text-left rtl:text-right text-gray-500">
                <tbody>

                  <tr className="bg-white md:border md:border-b-borderGray">
                    <th scope="row" className="px-4 2xl:px-6 py-3 font-medium text-gray-900 border md:border-r-borderGray md:border-b-borderGray md:text-right">
                      Date Connected
                    </th>
                    <td className="px-4 2xl:px-6 py-3 md:text-left md:w-4/6 text-gray-700">
                      {formatDateTime(donor?.createdAt)}
                    </td>
                  </tr>
                  <tr className="bg-white md:border md:border-b-borderGray">
                    <th scope="row" className="px-4 2xl:px-6 py-3 font-medium text-gray-900 border md:border-r-borderGray md:border-b-borderGray md:text-right">
                      Status
                    </th>
                    <td className="px-4 2xl:px-6 py-3 md:text-left md:w-4/6 text-gray-700">
                      <div className="flex gap-3 items-center">
                        <span className={`badge ${donor.active == true && donor.blocked?.includes(me?.agencyId) ? "badge-danger" : "badge-success"}`}>
                          {donor.active == true && donor.blocked?.includes(me?.agencyId) ? "Blocked" : "Active"}
                        </span>
                        <label className="inline-flex items-center cursor-pointer">
                          <input type="checkbox" checked={donor.active === true && donor.blocked?.includes(me?.agencyId)} className="sr-only peer" onChange={(e) => handleEventBlock(e)} />
                          <span className="text-sm font-medium text-gray-600 me-2">{donor.active == true && donor.blocked?.includes(me?.agencyId) ? "Unblock" : "Block"} donor</span>
                          <div className="relative w-9 h-5 bg-gray-200 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-orange-500"></div>
                        </label>
                      </div>
                    </td>
                  </tr>
                  <tr className="bg-white md:border md:border-b-borderGray">
                    <th scope="row" className="px-4 2xl:px-6 py-3 font-medium text-gray-900 border md:border-r-borderGray md:border-b-borderGray md:text-right">
                      Email
                    </th>
                    <td className="px-4 2xl:px-6 py-3 text-left md:w-4/6 text-primary">
                      <Link className='text-primary' to={`mailto:${donor?.email}`}>{donor?.email}</Link>
                    </td>
                  </tr>

                  <tr className="bg-white md:border md:border-b-borderGray">
                    <th scope="row" className="px-4 2xl:px-6 py-3 font-medium text-gray-900 border md:border-r-borderGray md:border-b-borderGray md:text-right">
                      Alert Frequency
                    </th>
                    <td className="px-4 2xl:px-6 py-3 md:text-left md:w-4/6 text-gray-700">
                      {donor?.alertFrequency}
                    </td>
                  </tr>

                  <tr className="bg-white md:border md:border-b-borderGray">
                    <th scope="row" className="px-4 2xl:px-6 py-3 font-medium text-gray-900 border md:border-r-borderGray md:border-b-borderGray md:text-right">
                      Last login date
                    </th>
                    <td className="px-4 2xl:px-6 py-3 md:text-left md:w-4/6 text-gray-700">
                      {formatDateTime(donor?.lastLogin)}
                    </td>
                  </tr>
                  <tr className="bg-white md:border md:border-b-borderGray">
                    <th scope="row" className="px-4 2xl:px-6 py-3 font-medium text-gray-900 border md:border-r-borderGray md:border-b-borderGray md:text-right">
                      Last modified date
                    </th>
                    <td className="px-4 2xl:px-6 py-3 md:text-left md:w-4/6 text-gray-700">
                      {formatDateTime(donor?.lastActivityDate)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <h2 className='text-base lg:text-lg 2xl:text-2xl font-semibold mt-5'>Donation History {donations?.length} Donations ({formatToUSD(donationSum)}{" "}
              total)</h2>
            <div className="relative md:overflow-hidden md:border md:border-borderGray rounded-xl mt-5">
              <table className="table_responsive_block w-full text-xs 2xl:text-sm text-left rtl:text-right">
                <thead className="text-xs 2xl:text-sm text-gray-600 bg-gray-100 border-b">
                  <tr>
                    <th scope="col" className="px-4 2xl:px-6 py-3 font-medium">Donation #</th>
                    <th scope="col" className="px-4 2xl:px-6 py-3 font-medium">Donation Date</th>
                    <th scope="col" className="px-4 2xl:px-6 py-3 font-medium">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {donations?.map((donation: any, key: number) => (
                    <tr className={` border-b bg-white `} key={key}>
                      <td scope="row" data-title='Donation #' className="px-4 2xl:px-6 py-3 font-medium text-primary cursor-pointer whitespace-nowrap">
                        <Link
                          className="text-primary"
                          to={`/safenight/donations/donation-detail/${donation.donationId}`}
                        >
                          {donation?.sequenceId}
                        </Link>
                      </td>
                      <td data-title='Donation Date' className="px-4 2xl:px-6 py-3">{formatDateShort(donation?.donationDate)}</td>
                      <td data-title='Amount' className="px-4 2xl:px-6 py-3">{formatToUSD(donation?.amountReceived)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default DonorsDetails